import { Vector3 } from 'three';
import { Vertex } from '@thirdPartyLibraries/three-mesh-halfedge/src';
import HalfEdgeMesh from '@three/common/halfEdgeMesh/HalfEdgeMesh';

export interface SmoothingOptions {
  smoothingFactor?: number; // 0-1, how much to smooth (0 = no smoothing, 1 = full smoothing)
  iterations?: number; // number of smoothing iterations
}

export class SmoothBorder {
  private mesh: HalfEdgeMesh;

  constructor(mesh: HalfEdgeMesh) {
    this.mesh = mesh;
  }

  /**
   * Applies Laplacian smoothing to border vertices
   */
  public async smoothBorderVertices(options: SmoothingOptions = {}): Promise<void> {
    const { smoothingFactor = 0.5, iterations = 3 } = options;

    const borderVertices = this.mesh.getBorderVertices();
    if (borderVertices.length < 3) return;

    for (let iter = 0; iter < iterations; iter++) {
      const newPositions = new Map<Vertex, Vector3>();

      // Calculate new positions for all border vertices
      for (const vertex of borderVertices) {
        const neighbors = vertex.getAdjacenceBoundaryVertices();

        if (neighbors.length > 0) {
          // Calculate average position of neighbors
          const avgPosition = new Vector3();
          for (const neighbor of neighbors) {
            avgPosition.add(neighbor.position);
          }
          avgPosition.divideScalar(neighbors.length);

          // Blend between original and average position
          const smoothedPosition = vertex.position.clone().lerp(avgPosition, smoothingFactor);
          newPositions.set(vertex, smoothedPosition);
        }
      }

      // Apply new positions
      for (const [vertex, newPos] of newPositions) {
        vertex.position.copy(newPos);
      }
    }
  }
}
